import { render, staticRenderFns } from "./FormPainBody.vue?vue&type=template&id=1d63fcd6&"
import script from "./FormPainBody.vue?vue&type=script&lang=js&"
export * from "./FormPainBody.vue?vue&type=script&lang=js&"
import style0 from "./FormPainBody.vue?vue&type=style&index=0&id=1d63fcd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports